export default class FeaturedComponent extends HTMLElement {
  constructor() {
    super();
    // this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.render();
  }

  render() {
    this.innerHTML = "";

    const container = document.createElement("ul");
    container.className =
      "flex flex-row flex-wrap my-3 md:my-0 justify-evenly items-center";

    const featured = [
      {
        url: "https://ottawa.ctvnews.ca/entertainment-with-an-edge-axe-throwing-comes-to-ottawa-1.2515824",
        title: "Entertaiment with an edge axe comes to Ottawa",
        logo: "/wp-content/themes/badaxe/img/featured/ctv.png",
        name: "CTV",
      },
      {
        url: "https://www.thrillist.com/entertainment/atlanta/best-cheap-date-ideas-atlanta",
        title: "The best Atlanta date ideas for under $20",
        logo: "/wp-content/themes/badaxe/img/featured/thrillist.png",
        name: "Thrillist",
      },
      {
        url: "https://abc7chicago.com/entertainment/indoor-axe-throwing-facility-opens-in-west-loop/1504200/",
        title: "Indoor axe throwing facility opens in West Loop",
        logo: "/wp-content/themes/badaxe/img/featured/abc.png",
        name: "ABC",
      },
      {
        url: "https://www.usatoday.com/story/sports/ftw/2017/07/06/chase-elliott-shows-off-axe-throwing-skills/103485750/",
        title: "Chase Elliott shows off axe throwing skills",
        logo: "/wp-content/themes/badaxe/img/featured/usa-today.png",
        name: "USA Today",
      },
      {
        url: "https://okcfox.com/news/morning-news/bad-axe-throwing",
        title: "Bad Axe Throwing",
        logo: "/wp-content/themes/badaxe/img/featured/fox-news.png",
        name: "Fox News",
      },
      {
        url: "https://www.vice.com/en_us/article/43db8g/how-to-spend-a-night-in-chicago",
        title: "How to spend a night in Chicago",
        logo: "/wp-content/themes/badaxe/img/featured/vice.png",
        name: "VICE",
      },
      {
        url: "https://www.huffingtonpost.com/entry/the-rising-popularity-of-axe-throwing_us_58a848abe4b026a89a7a2ba0",
        title: "The Rising Popularity Of Axe Throwing",
        logo: "/wp-content/themes/badaxe/img/featured/huffpost.png",
        name: "Huffpost",
      },
      {
        url: "https://www.chicagotribune.com/lifestyles/ct-axe-throwing-parties-0823-20160823-story.html",
        title: "Axe throwing — the 'modern-day bowling' — coming to Chicago",
        logo: "/wp-content/themes/badaxe/img/featured/chicago-tribune.png",
        name: "Chicago Tribune",
      },
      {
        url: "https://www.vancitybuzz.com/2016/04/bad-axe-throwing-brings-the-fine-art-of-axe-throwing-to-surrey/",
        title: "You can now throw axes (legally) in Surrey",
        logo: "/wp-content/themes/badaxe/img/featured/vancitybuzz.png",
        name: "Van City Buzz",
      },
      {
        url: "https://www.sfchronicle.com/entertainment/article/Finally-a-place-to-be-a-total-Bad-Axe-11281398.php",
        title: "Finally, a place to be a total ‘Bad Axe’",
        logo: "/wp-content/themes/badaxe/img/featured/san-francisco-chronicles.png",
        name: "San Francisco Chronicle",
      },
      {
        url: "https://sportsgames88.sportsblog.com/posts/32067191/axe-throwing-is-the-new-bowling.html",
        title: "Axe Throwing is The New Bowling",
        logo: "/wp-content/themes/badaxe/img/featured/sportsblog.png",
        name: "Sportsblog",
      },
      {
        url: "https://www.craveonline.ca/culture/1217823-world-axe-throwing-league-will-soon-thing#/slide/1",
        title: "‘World Axe Throwing League’ Will Soon Be A Thing",
        logo: "/wp-content/themes/badaxe/img/featured/crave.png",
        name: "Crave",
      },
      {
        url: "https://www.cnn.com/videos/us/2016/12/04/axe-throwing-leagues-orig-vstan.cnn",
        title: "Ax throwing: The new bar sport",
        logo: "/wp-content/themes/badaxe/img/featured/cnn.png",
        name: "CNN",
      },
      {
        url: "https://www.washingtonpost.com/lifestyle/style/competitive-ax-throwing-is-an-actual-thing-and-apparently-its-best-done-with-beer/2016/09/30/0015175a-7c1f-11e6-beac-57a4a412e93a_story.html",
        title:
          "Competitive axe-throwing is an actual thing, and apparently it’s best done with beer",
        logo: "/wp-content/themes/badaxe/img/featured/the-washington-post.png",
        name: "The Washington Post",
      },
      {
        url: "https://globalnews.ca/video/2653305/global-news-morning-crew-tries-axe-throwing-for-the-first-time",
        title: "Global News Morning crew tries axe throwing for the first time",
        logo: "/wp-content/themes/badaxe/img/featured/global-news.png",
        name: "Global News",
      },
      {
        url: "https://www.trendhunter.com/trends/bad-axe-throwing-1",
        title: "Competitive Axe Throwing Clubs",
        logo: "/wp-content/themes/badaxe/img/featured/trendhunter.png",
        name: "Trend Hunter",
      },
      {
        url: "https://www.facebook.com/BuzzFeedVideo/posts/2137105373097000",
        title: "This looks awesome",
        logo: "/wp-content/themes/badaxe/img/featured/buzzfeed-video.png",
        name: "BuzzFeed Video",
      },
      {
        url: "https://www.indystar.com/story/entertainment/2017/06/01/ax-throwing-thing-you-didnt-know-you-needed-try/361302001/",
        title: "You can now throw axes in Downtown Indy. Here's where.",
        logo: "/wp-content/themes/badaxe/img/featured/indystar.png",
        name: "Indystar",
      },
      {
        url: "https://www.denverpost.com/2017/06/19/two-ax-throwing-venues-swing-into-denver/",
        title: "Two ax-throwing venues swing into Denver",
        logo: "/wp-content/themes/badaxe/img/featured/the-denver-post.png",
        name: "The Denver Post",
      },
      {
        url: "https://www.dnainfo.com/chicago/20160928/west-loop/bad-axe-throwing-indoor-facility",
        title: "Bad Axe Throwing indoor facility",
        logo: "/wp-content/themes/badaxe/img/featured/dna-info.png",
        name: "DNA info",
      },
      {
        url: "https://www.exsplore.com/blog/interview-with-founder-of-bad-axe-throwing",
        title: "Are Axe Throwing Ranges Coming to California?",
        logo: "/wp-content/themes/badaxe/img/featured/exsplore.png",
        name: "Exsplore",
      },
      {
        url: "https://www.al.com/life/2019/08/axe-throwing-venue-to-open-doors-aug-23-in-spanish-fort.html",
        title: "Axe-throwing venue to open doors Aug. 23 in Spanish Fort",
        logo: "/wp-content/themes/badaxe/img/featured/aldotcom.png",
        name: "AL.com",
      },
      {
        url: "https://uproxx.com/life/where-to-eat-drink-minneapolis/",
        title:
          "Pro Skater Nicole Hause Tells Us Where To Eat, Drink, And Play If You’re In Minneapolis For This Weekend’s X Games",
        logo: "/wp-content/themes/badaxe/img/featured/uproxx.png",
        name: "Uproxx",
      },
      {
        url: "https://www.syracuse.com/entertainment/2019/03/throw-axes-like-warriors-at-new-camillus-bar-in-township-5-video.html",
        title:
          "Throw axes like warriors at new Camillus bar in Township 5 (video)",
        logo: "/wp-content/themes/badaxe/img/featured/syracuse.png",
        name: "Syracuse",
      },
      {
        url: "https://www.cbc.ca/news/canada/windsor/axe-throwing-sport-windsor-1.4930186",
        title: "There's a new sport in town: Axe throwing",
        logo: "/wp-content/themes/badaxe/img/featured/cbc.png",
        name: "CBC",
      },
      {
        url: "https://www.thebusinessjournal.com/heads-up-ax-throwing-spot-hurtling-toward-fresno/",
        title: "HEAD’S UP: AX-THROWING SPOT HURTLING TOWARD FRESNO",
        logo: "/wp-content/themes/badaxe/img/featured/thebusinessjournal.png",
        name: "The Business Journal",
      },
      {
        url: "https://cbs4indy.com/2018/11/21/bad-axe-throwing-turns-canadas-favorite-backyard-pastime-into-downtown-indys-coolest-group-activity/",
        title:
          "Bad Axe Throwing turns Canada’s favorite backyard pastime into downtown Indy’s coolest group activity",
        logo: "/wp-content/themes/badaxe/img/featured/cbs.png",
        name: "CBS",
      },
      {
        url: "https://whatnowatlanta.com/bad-axe-throwing-atlanta-moving/",
        title:
          "Bad Axe Throwing Is Relocating its Atlanta Facility, Quadrupling In Size",
        logo: "/wp-content/themes/badaxe/img/featured/whatnowatlanta.png",
        name: "What Now Atlanta",
      },
      {
        url: "https://dallas.eater.com/2019/6/24/18715811/spend-fourth-of-july-weekend-hurling-an-ax-at-this-new-fort-worth-outpost",
        title:
          "Spend Fourth of July Weekend Hurling an Ax at This New Fort Worth Outpost",
        logo: "/wp-content/themes/badaxe/img/featured/eater.png",
        name: "Eater",
      },
      {
        url: "https://www.nbcwashington.com/entertainment/the-scene/Ax-Throwing-Bars-Venues-Plan-To-Sell-Alcohol-And-They-Assure-You-Its-Safe-498682451.html",
        title:
          "DC Ax-Throwing Venues Plan to Sell Alcohol, and Assure You It's Safe",
        logo: "/wp-content/themes/badaxe/img/featured/nbc.png",
        name: "NBC",
      },
    ];

    featured.forEach((item, index) => {
      const listItem = document.createElement("li");
      listItem.className = "w-1/6";

      const link = document.createElement("a");
      link.href = item.url;
      link.title = item.title;
      link.target = "_blank";
      link.className =
        "border-2 border-gray-200 p-0.5 md:p-4 block h-12 w-12 md:h-20 md:w-20 mx-auto mb-4 flex items-center justify-center";

      const image = document.createElement("img");
      image.src = item.logo;
      image.alt = item.name;
      image.className = "lazyload";

      // Create the tooltip element
      const tooltip = document.createElement("div");
      tooltip.className = "tooltip"; // Add a class for styling
      tooltip.textContent = item.title; // Set the tooltip text
      tooltip.style.position = "absolute";
      tooltip.style.visibility = "hidden";
      tooltip.className = "bg-brand text-white text-xs px-2 py-1 rounded";
      tooltip.role = "tooltip";

      const triangle = document.createElement("div");
      triangle.className =
        "absolute w-0 h-0 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-4 border-t-brand border-brand transform rotate-45";

      tooltip.appendChild(triangle);

      this.appendChild(tooltip);

      link.appendChild(image);
      listItem.appendChild(link);

      link.addEventListener("mouseenter", function() {
        const rect = link.getBoundingClientRect();

        tooltip.style.top = `${rect.top - 30 + window.scrollY}px`;
        tooltip.style.left = `${rect.left + window.scrollX}px`;

        tooltip.style.visibility = "visible";
      });

      link.addEventListener("mouseleave", function() {
        tooltip.style.visibility = "hidden";
      });

      container.appendChild(listItem);
    });

    this.appendChild(container);
    this.lazyLoadImages();
  }

  lazyLoadImages() { }
}
